import { render, staticRenderFns } from "./AttendOrders.vue?vue&type=template&id=4ca031e6&scoped=true&"
import script from "./AttendOrders.vue?vue&type=script&lang=js&"
export * from "./AttendOrders.vue?vue&type=script&lang=js&"
import style0 from "./AttendOrders.vue?vue&type=style&index=0&id=4ca031e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca031e6",
  null
  
)

export default component.exports